module.exports = __webpack_public_path__ + "img/2780400_s.2aa759d4.jpg";